import * as XLSX from 'xlsx';
import { Injectable } from '@angular/core';
import { formatDate } from '@angular/common';

@Injectable({
  providedIn: 'root' 
})
export class AppUtils {
 constructor() {}
  public mimeType = 'application/pdf';

  exportToCSV(data, filename, headerList) {
    let csvData = this.convertToCSV(data, headerList);
    // console.log('CSV', csvData);
    let blob = new Blob(['\uFEFF' + csvData], { type: 'text/csv;charset=utf-8;' });
    let dwldLink = document.createElement('a');
    let url = URL.createObjectURL(blob);
    let isSafariBrowser = navigator.userAgent.indexOf('Safari') != -1 && navigator.userAgent.indexOf('Chrome') == -1;
    if (isSafariBrowser) {
      //if Safari open in new window to save file with random filename.
      dwldLink.setAttribute('target', '_blank');
    }
    dwldLink.setAttribute('href', url);
    dwldLink.setAttribute('download', filename + '.csv');
    dwldLink.style.visibility = 'hidden';
    document.body.appendChild(dwldLink);
    dwldLink.click();
    document.body.removeChild(dwldLink);
  }

  convertToCSV(objArray, headerList) {

    // ReconciliationStats - Pie Chart
    let strStat = '';
    let rowStat = 'S.No,';
    for (let i in headerList.ReconciliationStatsHeader) {
      rowStat += headerList.ReconciliationStatsHeader[i] + ',';
    }
    rowStat = rowStat.slice(0, -1);
    strStat += rowStat + '\r\n';
    for (let i = 0; i < objArray.ReconciliationStatsValue.length; i++) {
        let line = i + 1 + '';
        line += ',' + objArray.ReconciliationStatsValue[i] || '';
        strStat += line + '\r\n';
    }

    // ReconciliationData - Contacts
    let str = '';
    let row = 'S.No,';
    for (let i in headerList.ReconciliationDataHeader) {
      row += headerList.ReconciliationDataHeader[i] + ',';
    }
    row = row.slice(0, -1);
    str += row + '\r\n';
    for (let i = 0; i < objArray.ReconciliationDataValue.length; i++) {
        let line = i + 1 + '';
        line += ',' + objArray.ReconciliationDataValue[i] || '';
        str += line + '\r\n';
    }

    // AccountSummary
    let accStr = '';
    let accountRow = 'S.No,';
    for (let i in headerList.AccountSummaryHeader) {
      accountRow += headerList.AccountSummaryHeader[i] + ',';
    }
    accountRow = accountRow.slice(0, -1);
    accStr += accountRow + '\r\n';
    for (let i = 0; i < objArray.AccountSummaryValue.length; i++) {
        let line = i + 1 + '';
        line += ',' + objArray.AccountSummaryValue[i] || '';
        accStr += line + '\r\n';
    }

    // FeedbackForms
    let feedbackStr = '';
    let feedbackRow = 'S.No,';
    for (let i in headerList.FeedbackFormsHeader) {
      feedbackRow += headerList.FeedbackFormsHeader[i] + ',';
    }
    feedbackRow = feedbackRow.slice(0, -1);
    feedbackStr += feedbackRow + '\r\n';
    for (let i = 0; i < objArray.FeedbackFormsValue.length; i++) {
        let line = i + 1 + '';
        line += ',' + objArray.FeedbackFormsValue[i] || '';
        feedbackStr += line + '\r\n';
    }

    // Result
    let res = '';
    res = 'SEP=,' + '\r\n' + strStat + '\r\n' + 'ACCOUNTS' + '\r\n' + accStr + '\r\n' + 'CONTACTS' + '\r\n' + str + '\r\n' + 'FEEDBACK FORMS' + '\r\n' + feedbackStr;
    return res;
  }

  exportToExcel(arr: any[], name?: string) {
    let { sheetName, fileName } = this.getFileName(name);

    var wb = XLSX.utils.book_new();
    var ws = XLSX.utils.json_to_sheet(arr);
    XLSX.utils.book_append_sheet(wb, ws, sheetName);
    XLSX.writeFile(wb, `${fileName}.xlsx`);
  }

  getFileName = (name: string) => {
    let timeSpan = new Date().toISOString();
    let sheetName = name || 'ExportResult';
    let fileName = `${sheetName}-${timeSpan}`;
    return {
      sheetName,
      fileName
    };
  };

  fetchDoc(apiURL, apikey?, accessToken?, fileName?) {
    let options = {
      method: 'GET',
      headers: {}
    };
    if(accessToken) {
      options = {
        method: 'GET',
        headers: {
          'x-api-key': apikey,
          'Authorization': accessToken
        }
      };
    }
    let isDownloadable = false;
    if(fileName) {
      this.mimeType = this.getMimeType(fileName);
      const ext = fileName ? fileName.split('.').pop() : '';
      const downloadableFile = ['csv','xls','xlsx','doc','docx','ppt','pptx','zip','tar','rar','gzip','txt', 'pdf'];
      isDownloadable = (downloadableFile.indexOf(ext) >= 0);
    }
    let self = this;
    fetch(apiURL, options)
      .then(handleErrors)
      .then(r => r.blob())
      .then(function(blob){
        // this.showFile
        let newBlob = new Blob([blob], { type: self.mimeType }); //'application/pdf'
        const data = window.URL.createObjectURL(newBlob);
        //window.open(data, '_blank')
        var link = document.createElement('a');
        link.href = data;
        link.target = '_blank';
        if(isDownloadable) {
            link.download = fileName;
        }
        link.click();
        // commented on 30/01/2023 because BLOB pdf downloading was having issue
        // setTimeout(function() {
        // // For Firefox it is necessary to delay revoking the ObjectURL
        // window.URL.revokeObjectURL(data);
        // }, 100);
      })
      .catch(error => {
        // console.log('ERROR: ' + error)
      });

    function handleErrors(response) {
    if (!response.ok) {
        throw Error(response.statusText);
    }
    return response;
    }
  }

  public showFile(blob) {
    var newBlob = new Blob([blob], { type: blob.type }); //'application/pdf'
    const data = window.URL.createObjectURL(newBlob);
    window.open(data, '_blank');
    // var link = document.createElement('a');
    // link.href = data;
    // link.target = '_blank';
    // link.click();
    // setTimeout(function() {
    //   // For Firefox it is necessary to delay revoking the ObjectURL
    //   window.URL.revokeObjectURL(data);
    // }, 100);
  }

  formatFilesIcons(filename: string) {
    const ext = filename ? filename.split('.').pop() : '';
    let fileIcon = 'file_pdf';
    switch (ext) {
      case 'apng':
      case 'bmp':
      case 'gif':
      case 'pjpeg':
      case 'png':
      case 'jpeg':
      case 'jpg':
      case 'PNG':
        fileIcon = 'image';
        break;
      case 'csv':
      case 'xls':
      case 'xlsx':
        fileIcon = 'file_excel';
        break;
      case 'doc':
      case 'docx':
        fileIcon = 'file_word';
        break;
      case 'pdf':
        fileIcon = 'file_pdf';
        break;
      case 'ppt':
      case 'pptx':
        fileIcon = 'document';
        break;
      case 'zip':
      case 'tar':
      case 'rar':
      case 'gzip':
        fileIcon = 'file_folder';
        break;
      case 'txt':
        fileIcon = 'document'; // icon is not available , temp document used
        break;
      default:
        fileIcon = 'document'; // icon is not available , temp document used
        break;
    }
    return fileIcon;
  }

  getMimeType(fileName: string) {
    let tokens = fileName ? fileName.split('.').pop() : '';
    let fileExtension = '.' + tokens.toLowerCase();
    switch(fileExtension) {
        case('.aac'):
            return('audio/aac');
            break;
        case('.abw'):
            return('application/x-abiword');
            break;
        case('.arc'):
            return('application/x-freearc');
            break;
        case('.avi'):
            return('video/x-msvideo');
            break;
        case('.azw'):
            return('application/vnd.amazon.ebook');
            break;
        case('.bin'):
            return('application/octet-stream');
            break;
        case('.bmp'):
            return('image/bmp');
            break;
        case('.bz'):
            return('application/x-bzip');
            break;
        case('.bz2'):
            return('application/x-bzip2');
            break;
        case('.cda'):
            return('application/x-cdf');
            break;
        case('.csh'):
            return('application/x-csh');
            break;
        case('.css'):
            return('text/css');
            break;
        case('.csv'):
            return('text/csv');
            break;
        case('.doc'):
            return('application/msword');
            break;
        case('.docx'):
            return('application/vnd.openxmlformats-officedocument.wordprocessingml.document');
            break;
        case('.eot'):
            return('application/vnd.ms-fontobject');
            break;
        case('.epub'):
            return('application/epub+zip');
            break;
        case('.gz'):
            return('application/gzip');
            break;
        case('.gif'):
            return('image/gif');
            break;
        case('.htm'):
            return('text/html');
            break;
        case('.ico'):
            return('image/vnd.microsoft.icon');
            break;
        case('.ics'):
            return('text/calendar');
            break;
        case('.jar'):
            return('application/java-archive');
            break;
        case('.jpeg'):
            return('image/jpeg');
            break;
        case('.js'):
            return('text/javascript');
            break;
        case('.json'):
            return('application/json');
            break;
        case('.jsonld'):
            return('application/ld+json');
            break;
        case('.mid'):
            return('audio/midi audio/x-midi');
            break;
        case('.midi'):
            return('audio/midi audio/x-midi');
            break;
        case('.mjs'):
            return('text/javascript');
            break;
        case('.mp3'):
            return('audio/mpeg');
            break;
        case('.mp4'):
            return('video/mp4');
            break;
        case('.mpeg'):
            return('video/mpeg');
            break;
        case('.mpkg'):
            return('application/vnd.apple.installer+xml');
            break;
        case('.odp'):
            return('application/vnd.oasis.opendocument.presentation');
            break;
        case('.ods'):
            return('application/vnd.oasis.opendocument.spreadsheet');
            break;
        case('.odt'):
            return('application/vnd.oasis.opendocument.text');
            break;
        case('.oga'):
            return('audio/ogg');
            break;
        case('.ogv'):
            return('video/ogg');
            break;
        case('.ogx'):
            return('application/ogg');
            break;
        case('.opus'):
            return('audio/opus');
            break;
        case('.otf'):
            return('font/otf');
            break;
        case('.png'):
            return('image/png');
            break;
        case('.pdf'):
            return('application/pdf');
            break;
        case('.php'):
            return('application/x-httpd-php');
            break;
        case('.ppt'):
            return('application/vnd.ms-powerpoint');
            break;
        case('.pptx'):
            return('application/vnd.openxmlformats-officedocument.presentationml.presentation');
            break;
        case('.rar'):
            return('application/vnd.rar');
            break;
        case('.rtf'):
            return('application/rtf');
            break;
        case('.sh'):
            return('application/x-sh');
            break;
        case('.svg'):
            return('image/svg+xml');
            break;
        case('.swf'):
            return('application/x-shockwave-flash');
            break;
        case('.tar'):
            return('application/x-tar');
            break;
        case('.tif'):
            return('image/tiff');
            break;
        case('.tiff'):
            return('image/tiff');
            break;
        case('.ts'):
            return('video/mp2t');
            break;
        case('.ttf'):
            return('font/ttf');
            break;
        case('.txt'):
            return('text/plain');
            break;
        case('.vsd'):
            return('application/vnd.visio');
            break;
        case('.wav'):
            return('audio/wav');
            break;
        case('.weba'):
            return('audio/webm');
            break;
        case('.webm'):
            return('video/webm');
            break;
        case('.webp'):
            return('image/webp');
            break;
        case('.woff'):
            return('font/woff');
            break;
        case('.woff2'):
            return('font/woff2');
            break;
        case('.xhtml'):
            return('application/xhtml+xml');
            break;
        case('.xls'):
            return('application/vnd.ms-excel');
            break;
        case('.xlsx'):
            return('application/vnd.openxmlformats-officedocument.spreadsheetml.sheet');
            break;
        case('.xml'):
            return('application/xml');
            break;
        case('.xul'):
            return('application/vnd.mozilla.xul+xml');
            break;
        case('.zip'):
            return('application/zip');
            break;
        case('.3gp'):
            return('video/3gpp');
            break;
        case('.3g2'):
            return('video/3gpp2');
            break;
        case('.7z'):
            return('application/x-7z-compressed');
            break;
        default:
            return 'application/octet-stream';
    }
  }

  getLowerCase(data) {
    let lowercaseData = (data) ? data.toString().toLowerCase() : '';
    return lowercaseData;
  }
  
  /**
   * 
   * Input : "<p>My document body</p><p>where is output</p>"
   * output : My document bodywhere is output
   */
  extractContent(html) { 
    return new DOMParser().parseFromString(html, "text/html") . 
        documentElement.textContent;
  }

  // format date to dd-mmm-yyyy (07-Jan-2021)
  public formatDateOnly(dateValue: Date): string {
    if(dateValue) {
        const date = new Date(dateValue);
        const day = date.toLocaleString('en-US', { day: '2-digit' });
        const month = date.toLocaleString('en-US', { month: 'short' });
        const year = date.toLocaleString('en-US', { year: 'numeric' });
        return day + '-' + month + '-' + year;
    } else {
        return '';
    }
  }

  formatDateWithTime(dateValue: Date) {
    if(dateValue) {
        let localDate = new Date(dateValue);
        // let localDate = date.toLocaleString('default', { hourCycle:'h24' });
        const day = localDate.toLocaleString('en-US', { day: '2-digit' });
        const month = localDate.toLocaleString('en-US', { month: 'short' });
        const year = localDate.toLocaleString('en-US', { year: 'numeric' });
        const hour = localDate.toLocaleString('en-US', { hour12:false, hour: '2-digit' });
        let minute = localDate.toLocaleString('en-US', { hour12:false, minute: '2-digit' });
            minute = (parseInt(minute) < 10) ? `0${minute}`:minute;
        return day + '-' + month + '-' + year + ' ' + hour+':'+minute;
    } else {
        return '';
    }
  }

  formatDateWithTimeUptoSec(dateValue: Date) {
    if(dateValue) {
        let localDate = new Date(dateValue);
        // let localDate = date.toLocaleString('default', { hourCycle:'h24' });
        const day = localDate.toLocaleString('en-US', { day: '2-digit' });
        const month = localDate.toLocaleString('en-US', { month: 'short' });
        const year = localDate.toLocaleString('en-US', { year: 'numeric' });
        const hour = localDate.toLocaleString('en-US', { hour12:false, hour: '2-digit' });
        let minute = localDate.toLocaleString('en-US', { hour12:false, minute: '2-digit' });
            minute = (parseInt(minute) < 10) ? `0${minute}`:minute;
        let second = localDate.toLocaleString('en-US', { hour12:false, second: '2-digit' });
            second = (parseInt(second) < 10) ? `0${second}`:second;
        return day + '-' + month + '-' + year + ' ' + hour+':'+minute+':'+second;
    } else {
        return '';
    }
  }

    downloadExcel(data, filename) {
        
        const wb = XLSX.utils.book_new();

        // STATISTICS
        const statistics = data.ReconciliationStats.map((row, index) => {
            return { 'S.No': index + 1, ...row };
        });
        const ws1 = XLSX.utils.json_to_sheet(statistics);
        XLSX.utils.book_append_sheet(wb, ws1, 'STATISTICS');

        // ACCOUNTS
        const feedbackForms = Array.isArray(data.FeedbackForms) ? data.FeedbackForms[0] : {};
        const accounts = data.AccountSummary.map((row, index) => {
           const newrow = { 'S.No': index + 1 };
           Object.keys(row).forEach(key=>{
            const feedbackValueMatch = key.match(/^Feedback(\d+)Value$/i);
            if(feedbackValueMatch){
                const feedbackIndex = feedbackValueMatch[1];
                if(feedbackForms[`Feedback${feedbackIndex}Label`] !== undefined){
                    newrow[`Feedback${feedbackIndex}Label`] = feedbackForms[`Feedback${feedbackIndex}Label`];
                }
                if(feedbackForms[`Feedback${feedbackIndex}Type`] !== undefined){
                    newrow[`Feedback${feedbackIndex}Type`] = feedbackForms[`Feedback${feedbackIndex}Type`];
                }
                if(feedbackForms[`Feedback${feedbackIndex}Mandatory`] !== undefined){
                    newrow[`Feedback${feedbackIndex}Mandatory`] = feedbackForms[`Feedback${feedbackIndex}Mandatory`];
                }
           }
            const cellVal = row[key];
            if (cellVal && typeof cellVal === 'object' && !Array.isArray(cellVal) && cellVal.fileName) {
                newrow[key] = cellVal.fileName;
            } else {
                newrow[key] = Array.isArray(cellVal) ? cellVal.join(', ') : cellVal;
            }
        })
        return newrow;
        });
        const ws2 = XLSX.utils.json_to_sheet(accounts);
        XLSX.utils.book_append_sheet(wb, ws2, 'ACCOUNTS');

        // CONTACTS
        const contacts = data.ReconciliationData.map((row, index) => {
            return { 'S.No': index + 1, ...row };
        });
        const ws3 = XLSX.utils.json_to_sheet(contacts);
        XLSX.utils.book_append_sheet(wb, ws3, 'CONTACTS');
        
        // Download File
        const wbout = XLSX.write(wb, { bookType: 'xlsx', type: 'binary' });
        const blob = new Blob([this.stringToArrayBuffer(wbout)], { type: 'application/octet-stream' });

        let dwldLink = document.createElement('a');
        let url = URL.createObjectURL(blob);

        let isSafariBrowser = navigator.userAgent.indexOf('Safari') != -1 && navigator.userAgent.indexOf('Chrome') == -1;
        if (isSafariBrowser) {
          dwldLink.setAttribute('target', '_blank');
        }

        dwldLink.setAttribute('href', url);
        dwldLink.setAttribute('download', filename + '.xlsx');
        dwldLink.style.visibility = 'hidden';
        document.body.appendChild(dwldLink);
        dwldLink.click();
        document.body.removeChild(dwldLink);
    }

    stringToArrayBuffer(s) {
        const buf = new ArrayBuffer(s.length);
        const view = new Uint8Array(buf);
        for (let i = 0; i < s.length; i++) {
            view[i] = s.charCodeAt(i) & 0xFF;
        }
        return buf;
    }

     public getColor(ntStatus: string): string {
    switch (ntStatus) {
      case 'New':
        return 'New';
      case 'Read':
        return 'Read';
      case 'Completed':
        return 'Completed';
      case 'Feedback Overdue':
        return 'Feedback-Overdue';
      case 'Feedback Submitted':
        return 'Feedback-Submitted';
      case 'Feedback Received':
        return 'Feedback-Submitted';
      case 'Reminder':
        return 'Reminder';
      default:
        return 'Feedback-Submitted';
    }
  }

  public formatDateString(date: Date): string {
  return formatDate(date, 'd-MMM-yyyy', 'en-US');
}

}
